import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import { BulkChangeWarningMessage } from 'components/upcomingTreatments/dialogs/BulkChangeWarningMessage';
import { useRemoveFromBatchMutation } from 'store/api/goLiveApi';

const Title = 'Remove from batch';

export const RemoveFromBatchDialog = ({
    isOpen,
    onClose,
    treatmentsCount = 0,
    apiQueryParams = undefined,
}) => {
    const [removeFromBatch] = useRemoveFromBatchMutation();

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            onSubmit={async () => {
                await removeFromBatch(apiQueryParams).unwrap();
                SuccessToast({ message: 'Treatments successfully removed from batch.' });
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <BulkChangeWarningMessage
                            apiQueryParams={apiQueryParams}
                            treatmentsCount={treatmentsCount}
                        />
                    }
                />
            )}
        </Formik>
    );
};

RemoveFromBatchDialog.Title = Title;

RemoveFromBatchDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentsCount: PropTypes.number,
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
    }),
};
